import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GnbWrap, HeaderWrap, Icons, Logo, TitleSelectDiv } from "header/headerStyle";
import Nav from "./Nav";
import { Link, useLocation } from "react-router-dom";

const LogoDiv = () => {
    return (
        <Logo>
            <span style={{ color: "#2000a0" }}>B</span>
            <span style={{ color: "#5530f4" }}>P</span>
            <span style={{ color: "#a498ff" }}>L</span>
        </Logo>
    );
};

const Header = () => {
    const userSelector = useSelector((store) => store.user);
    const { isAdmin, isReader, isWriter, isReviewer, isExternal, isSuperVisor } = userSelector;
    const path = window.location.pathname.substring(1, window.location.pathname.length);
    const common = useSelector((store) => store.common);
    const internal = common.external === "false";
    const location = useLocation();

    // useEffect(() => {
    //     console.log(location.pathname); // location 변경 감지
    // }, [location]);

    return (
        <HeaderWrap>
            <Nav />

            <GnbWrap>
                <div className="logo">
                    <h1>
                        <Link to={`/`}>
                            <LogoDiv />
                        </Link>
                    </h1>
                </div>
                <div className={`title`}>
                    <TitleSelectDiv></TitleSelectDiv>
                </div>
                <ul className="menu">
                    {userSelector.userId && (
                        <>
                            {(isReader || isWriter || isReviewer || isReader || isExternal || isSuperVisor || isAdmin) && (
                                <li>
                                    <Link to={"/myPage"} replace>{`Home`}</Link>
                                </li>
                            )}

                            {(isReader || isWriter) && internal && (
                                <li className={`has-child`}>
                                    <p>List</p>
                                    <div className={`sub-menu`}>
                                        <ul>
                                            <li>
                                                <Link to={"/sheetList"}>{`MBR Sheet`}</Link>
                                            </li>
                                            <li>
                                                <Link to={"/PCSList"}>{`PCS`}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            )}
                            {isWriter && internal && (
                                <li className={`has-child`}>
                                    <p>Draft</p>
                                    <div className={`sub-menu`}>
                                        <ul>
                                            <li>
                                                <Link to={"/mainForm"}>{`MBR Sheet`}</Link>
                                            </li>
                                            <li>
                                                <Link to={"/mainDesc"}>{`Description`}</Link>
                                            </li>
                                            <li>
                                                <Link to={"/PCSGenerator"}>{`PCS`}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            )}
                            {(isReviewer || isExternal || isAdmin) && (
                                <li>
                                    <Link to={isExternal ? "/review-ex" : "/review"}>{`Comment`}</Link>
                                </li>
                            )}
                            {(isAdmin || isSuperVisor) && internal && (
                                <li>
                                    <Link to={"/admin"}>{`Admin`}</Link>
                                </li>
                            )}
                        </>
                    )}
                </ul>
            </GnbWrap>
        </HeaderWrap>
    );
};

export default Header;
